import { i18n } from './i18n';

export function formatLocaleDate(date: Date): string {
  const lang = i18n.getCurrentLanguage();
  const locale = lang === 'ko' ? 'ko-KR' : lang === 'id' ? 'id-ID' : 'en-US';
  return date.toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function localizeEventTitle(title: string, status?: 'upcoming' | 'active' | 'ended'): string {
  const lang = i18n.getCurrentLanguage();
  if (lang === 'ko') {
    let t = title || i18n.t('eventDefaultTitle');
    if (status === 'ended') {
      t = t.replace(/진행중/g, '').replace(/진행 중/g, '').trim();
      if (!t.includes('종료')) t += i18n.t('eventEndedSuffix');
    }
    return t;
  }

  let t = (title || i18n.t('eventDefaultTitle'))
    .replace(/진행\s*중/gi, '')
    .replace(/\(종료\)/g, '')
    .replace(/2차\s*BOOM?\s*이벤트/gi, '2nd BOOM Event')
    .replace(/1차\s*BOOM?\s*이벤트/gi, '1st BOOM Event')
    .replace(/BOOM?\s*이벤트/gi, 'BOOM Event')
    .replace(/붐\s*이벤트/gi, 'BOOM Event')
    .trim();

  if (status === 'ended') t += i18n.t('eventEndedSuffix');
  return t || i18n.t('eventDefaultTitle');
}

export function localizeEventDescription(desc: string): string {
  if (!desc) return i18n.t('eventDefaultDesc');
  if (i18n.getCurrentLanguage() === 'ko') return desc;

  const match = desc.match(/([\d,]+)\s*VTTN/);
  if (match && /총\s*상금|토너먼트/.test(desc)) {
    return i18n.t('eventDescTemplate').replace('{amount}', match[1]);
  }
  if (/참여/.test(desc)) return i18n.t('eventDefaultDesc');
  return desc;
}

export function localizePrizeLabel(label: string): string {
  if (i18n.getCurrentLanguage() === 'ko') return label;
  const map: Record<string, string> = {
    '1위': '1st Place',
    '2위': '2nd Place',
    '3위': '3rd Place',
    '4위': '4th Place',
    '5위': '5th Place',
  };
  if (map[label]) return map[label];
  const m = label.match(/^(\d+)위$/);
  if (m) {
    const n = parseInt(m[1], 10);
    const suffix = n === 1 ? 'st' : n === 2 ? 'nd' : n === 3 ? 'rd' : 'th';
    return `${n}${suffix} Place`;
  }
  return label;
}

export function formatWinnerCount(count: number): string {
  if (count <= 1) return '';
  const lang = i18n.getCurrentLanguage();
  if (lang === 'ko') return `(${count}명)`;
  if (lang === 'id') return `(${count} orang)`;
  return `(${count})`;
}

export function formatPrizeAmount(amount: number, count: number): string {
  const prefix = count > 1 ? i18n.t('prizeEachPrefix') : '';
  return `${prefix}${Number(amount).toLocaleString()} VTTN`;
}

/** Replace {key} placeholders in translation strings */
export function tr(key: keyof import('./i18n').Translations, vars: Record<string, string | number> = {}): string {
  let s = i18n.t(key);
  for (const [k, v] of Object.entries(vars)) {
    s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
  }
  return s;
}
